import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Api from "../../../../Services/Api";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { mapToObjectDDL } from "../../../common/mapper";

class ReceivingPartDGIFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      variantOptions: [],
      warnaOptions: [],
    };
  }

  async componentDidMount() {
    let apiList = [this.handleCallApi("variant")];
    if (!R.isNil(this.getDataValue("kodeVarian", null))) {
      apiList.push(
        this.handleCallApi(
          "warna",
          this.props.state.filterData.kodeVarian.value
        )
      );
    }
    const responses = await Promise.all(apiList);
    if (responses[0] && !R.isEmpty(responses[0])) {
      this.setState((prevValue) => ({
        ...prevValue,
        variantOptions: responses[0].map((v) =>
          mapToObjectDDL(v.kodeVariant, v.kodeVariant)
        ),
      }));
    }
    if (responses[1] && !R.isEmpty(responses[1])) {
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions: responses[1].map((w) =>
          mapToObjectDDL(w.namaWarnaKomersil, w.kodeWarna)
        ),
      }));
    }
  }

  handleCallApi = async (name, value) => {
    let api = Api.create("NAGAMAS_MASTER_DATA");
    let response;
    try {
      if (R.equals(name, "variant")) {
        response = await api.getAllVariant();
      } else {
        response = await api.getAllWarnaByParam({
          paramFilters: {
            kodeVariant: value,
          },
        });
      }

      if (response.ok) {
        return response.data.data;
      }
    } catch (error) {
      // TODO
    }

    return [];
  };

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleDateChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
  };

  handleVarianChange = async (name, value) => {
    this.handleValueChange("kodeWarna", null);
    this.handleValueChange(name, value);
    if (value) {
      const data = await this.handleCallApi("warna", value.value);
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions: data.map((w) =>
          mapToObjectDDL(w.namaWarnaKomersil, w.kodeWarna)
        ),
      }));
    }
  };

  getDataValue(fieldName, fallbackValue = "") {
    return !R.isNil(this.props.state.filterData) &&
      this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  }

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <FlexView column>
              <FlexView column vAlignContent="center">
                <div className="txt-site txt-11 txt-main txt-bold">
                  <h4>Tanggal SL:</h4>
                </div>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleDate
                    id="select_date_startDate"
                    name="startDate"
                    // nextdate
                    date={this.getDataValue("startDate", null)}
                    // maxDate={this.getDataValue("endDate", null)}
                    onChange={(value) =>
                      this.handleDateChange("startDate", value)
                    }
                  />
                  <span className="margin-bottom-20px">To</span>
                  <SimpleDate
                    id="select_date_endDate"
                    name="endDate"
                    backdate
                    minDate={this.getDataValue("startDate", null)}
                    date={this.getDataValue("endDate", null)}
                    onChange={(value) =>
                      this.handleDateChange("endDate", value)
                    }
                  />
                </FlexView>
              </FlexView>
              <SimpleInput
                id="input_text_no_shipping_list"
                name="shippingNo"
                label="No. Shipping List (SL)"
                value={this.getDataValue("shippingNo")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_receivedNo"
                name="receivedNo"
                label="No. Penerimaan"
                value={this.getDataValue("receivedNo")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <h3>Filter Detail</h3>
              <SimpleInput
                id="input_text_kode_part"
                name="partCode"
                label="Kode Part"
                value={this.getDataValue("partCode")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_nama_part"
                name="partName"
                label="Nama Part"
                value={this.getDataValue("partName")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_category"
                name="category"
                label="Kategori"
                value={this.getDataValue("category")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_text_no_po"
                name="purchaseOrderNo"
                label="No. PO"
                value={this.getDataValue("purchaseOrderNo")}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
            </FlexView>
            <FlexView hAlignContent="right" style={{ gap: "10px" }}>
              <SimpleButton
                type="button"
                secondary
                onClick={this.handleClearFilter}
              >
                Clear
              </SimpleButton>
              <SimpleButton onClick={this.props.onSubmit}>
                Terapkan
              </SimpleButton>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default ReceivingPartDGIFilter;
